export type UpdateComponentsDeletionFlagsRequest = {
  dipByRgn: string;
  cpntList: CpntList[];
};
export type CpntList = {
  index: number;
  cpntId: string;
  delFlg: string;
  updateDateTime: string;
};
